(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();

  ready(() => {
    const updateLine = (control, input, quantity) => {
      const lineKey = input && input.dataset.cartLineKey;
      if (!lineKey || control.dataset.updating === 'true') return;

      control.dataset.updating = 'true';
      control.querySelectorAll('button, input').forEach((element) => { element.disabled = true; });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart update failed');
          window.location.reload();
        })
        .catch(() => {
          control.dataset.updating = 'false';
          control.querySelectorAll('button, input').forEach((element) => { element.disabled = false; });
        });
    };

    document.querySelectorAll('[data-cart-qty-form]').forEach((control) => {
      const input = control.querySelector('[data-qty-input]');
      const setQty = (delta) => {
        if (!input) return;
        const current = parseInt(input.value || '0', 10) || 0;
        const next = Math.max(0, current + delta);
        input.value = next;
        updateLine(control, input, next);
      };

      const minus = control.querySelector('[data-qty-minus]');
      const plus = control.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => setQty(-1));
      if (plus) plus.addEventListener('click', () => setQty(1));
      if (input) input.addEventListener('change', () => {
        const next = Math.max(0, parseInt(input.value || '0', 10) || 0);
        input.value = next;
        updateLine(control, input, next);
      });
    });

    document.querySelectorAll('[data-focus-cart-note]').forEach((button) => button.addEventListener('click', () => {
      const note = document.getElementById('CartNote');
      if (note) note.focus();
    }));

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-suggestion-add]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      const variantId = Number(button.dataset.variantId);
      if (!variantId || button.disabled) return;

      button.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(async (response) => {
          if (!response.ok) throw new Error(await response.text());
          window.location.assign('/cart');
        })
        .catch(() => { button.disabled = false; });
    });
  });
})();